import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'obfuscateString',
})
export class ObfuscateStringPipe implements PipeTransform {
    transform(
        value: string | null | undefined,
        visibleStart = 4,
        visibleEnd = 4,
        mask = '****'
    ): string {
        if (!value) return '';

        value = String(value);
        if (value.length <= visibleStart + visibleEnd) return value;

        const start = value.slice(0, visibleStart);
        const end = value.slice(-visibleEnd);
        return `${start}${mask}${end}`;
    }
}
